import axios from "./orderInstance"

export default async (orderNumber: string, idType: string | string[] | undefined) => {
 try {
    const apiIdType = typeof idType === 'string' ? idType : 'id';
    const response: any = await axios(`/orders/${orderNumber}?idType=${apiIdType}`);
    return response.data;

  } catch (error) {
    console.error("Failed to fetch order:", error);
    return null;
  }
}
